export default __webpack_public_path__ + "static/media/pMATIC.2c2b226e.svg";